import React from 'react';

import { InicioDetailComp } from './components';

export function InicioDetail() {
    return <InicioDetailComp />;
}
